import type { ReactNode } from 'react';

import { MaintenanceScreen } from '@/components/MaintenanceScreen';
import { AdminI18nProvider } from '@/features/i18n/components/AdminI18nProvider';
import { useMaintenance } from '@/features/system/maintenance';

/**
 * Route guard: the merchant's signed-in screens give way to the maintenance
 * page while the platform is in FULL maintenance.
 *
 * Sits above every guard that fetches - the plan check, onboarding, the
 * subscribe step - not inside the dashboard layout, because those guards render
 * their own "could not load" states before the layout ever mounts. The first
 * refused request flips the maintenance store and this takes over; the screen
 * then hands back by itself when the window ends.
 *
 * Read-only leaves everything up: the banner says so, and a refused save says
 * so again.
 */
export function DashboardMaintenanceGate({ children }: { children: ReactNode }) {
  const maintenance = useMaintenance();
  if (maintenance?.mode !== 'FULL') return <>{children}</>;
  return (
    // Words the page in the merchant's language when it can; falls back to
    // plain wording when its own requests are refused too.
    <AdminI18nProvider>
      <MaintenanceScreen variant="dashboard" />
    </AdminI18nProvider>
  );
}
